import { LOG_LEVELS, loggerHelper } from 'utils/logger/loggerHelper';

function base64UrlToUint8Array(base64Url) {
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}

async function decryptPrefillData(encryptedData, base64Key) {
  const rawKey = base64UrlToUint8Array(base64Key);
  if (rawKey.length !== 32) {
    throw new Error('Invalid key length: ' + rawKey.length);
  }

  const key = await crypto.subtle.importKey(
    'raw',
    rawKey,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  );

  const encryptedBytes = base64UrlToUint8Array(encryptedData);

  const iv = encryptedBytes.slice(0, 12);
  const authTag = encryptedBytes.slice(encryptedBytes.length - 16);
  const ciphertext = encryptedBytes.slice(12, encryptedBytes.length - 16);

  const combinedCiphertext = new Uint8Array(ciphertext.length + authTag.length);
  combinedCiphertext.set(ciphertext);
  combinedCiphertext.set(authTag, ciphertext.length);

  try {
    const decrypted = await crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv: iv,
        tagLength: 128,
      },
      key,
      combinedCiphertext
    );

    const decoder = new TextDecoder();

    return decoder.decode(decrypted);
  } catch (e) {
    loggerHelper({
      level: LOG_LEVELS.ERROR,
      message: 'Error receiving lcm prefill data',
      info: e.message,
    });

    return null;
  }
}

export default decryptPrefillData;
